// eslint-disable-next-line import/no-named-as-default
import posthog from "posthog-js";
import { FALLBACK_FLAGS, FEATURE_FLAGS } from "~/experiments/posthog";
import { isBot } from "~/helpers/isBot";

export const UUID_COOKIE = "joszaki-uuid";
export const FLAGS_COOKIE = "joszaki-flags";

export default function (ctx, inject) {
  const uuid = getCookie(ctx, UUID_COOKIE);
  let posthogClient;
  let isVariant;

  let isFeatureEnabled;

  try {
    if (process.env.DEPLOY_STAGE === "production") {
      posthogClient = posthog.init(process.env.POSTHOG_TRACKER_ID, {
        api_host: process.env.POSTHOG_URL,
        ui_host: "https://eu.posthog.com",
        autocapture: false,
        capture_pageview: true,
        capture_pageleave: true,
        disable_session_recording: true,
        advanced_disable_flags: isBot(navigator.userAgent),
        // disable_persistence: true,
        bootstrap: {
          distinctID: uuid,
          isIdentifiedID: true,
          featureFlags: JSON.parse(getCookie(ctx, FLAGS_COOKIE)),
        },
        loaded: function (posthog) {
          posthog.identify(uuid);
        },
      });
      window.posthog = posthogClient;
      isVariant = (name, variant) =>
        (posthogClient.getFeatureFlag(name, { send_event: true }) ??
          FALLBACK_FLAGS[name]) === variant;

      isFeatureEnabled = (name) => {
        return posthogClient.isFeatureEnabled(name) ?? FALLBACK_FLAGS[name];
      };
    } else {
      // Local development and joszaki.space
      isVariant = (name, variant) => {
        const featureFlag = FEATURE_FLAGS.find((ff) => ff.name === name);
        return featureFlag?.local === variant;
      };
      posthogClient = null;

      isFeatureEnabled = (name) => {
        const featureFlag = FEATURE_FLAGS.find((ff) => ff.name === name);
        return !!featureFlag?.local;
      };
    }
  } catch (err) {
    console.error(err, "posthog setup error");
    ctx.$sentry.captureException(err, {
      tags: {
        posthog: "setup",
      },
    });
    isVariant = (name, variant) => FALLBACK_FLAGS[name] === variant;
    isFeatureEnabled = (name) => FALLBACK_FLAGS[name] ?? false;
    // Dummy posthog client that reports error to sentry
    // TODO log error to ELK?
    posthogClient = {
      capture: (event, data) => {
        console.error("Could not send posthog event", event, data);
        ctx.$sentry.captureMessage("Could not send posthog event", {
          tags: {
            event,
          },
        });
      },
      identify: (id, data) => {
        console.error("Could not send posthog identify", id, data);
        ctx.$sentry.captureMessage("Could not send posthog identify", {
          tags: {
            id,
          },
        });
      },
      loadToolbar: () => {
        console.error("Could not load posthog toolbar");
      },
    };
  }

  inject("ab", {
    isVariant,
  });

  inject("flags", {
    isFeatureEnabled,
  });

  inject("posthog", posthogClient);
  inject("uuid", uuid);
}

/**
 * Get the cookie that holds the ids and variants denoting the experiments assigned to the user
 *
 * @param {*} ctx Nuxt context
 * @param {string} name name of the cookie
 * @returns {string | null} the value of the cookie or null
 */
function getCookie(ctx, name) {
  if (process.server && !ctx.req) {
    return null;
  }

  try {
    return ctx.$cookie.get(name) || null;
  } catch (err) {
    console.error(err);
    ctx.$sentry.captureException(err, {
      tags: {
        ssr: "optimize",
      },
    });
  }
  return null;
}
